<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="header-title">Advanced Data Table</h4> -->
            <p class="text-muted font-13 mb-0"></p>
            <!-- Table -->
            <div>
              <good-table-column-search :moduleapi="`${this.baseApi}/cheque`" title="Cheque Return" :columns="columns"
                routerpath="/accounting/addchequereturn" :formOptions="formOptions" :edit="edit" :add="add"
                :canDelete="canDelete" :viewFields="viewFields" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/components/axios';
import GoodTableColumnSearch from "../../../components/GoodTableColumnSearch.vue";
import moment from "moment";
const baseApi = process.env.VUE_APP_APIENDPOINT;

export default {
  components: {
    GoodTableColumnSearch,
  },
  data() {
    return {
      baseApi: process.env.VUE_APP_APIENDPOINT,
      formOptions: {
        formTitle: `${this.$route.query.id ? "Edit ChequeReturn" : "Add ChequeReturn"
          }`,
        submitRouterPath: "/crm/chequereturn",
        usersDropdown: true,
        method: "post",
        action: "add",
        getEditValue: `${baseApi}/getchequeById`,
        url: `${baseApi}/chequereturn`,
        inputFields: [
          {
            name: "branch",
            value: 1,
            type: "hidden",
          },
          {
            name: "company",
            value: 1,
            type: "hidden",
          },
          // {
          //   name: "nextfollowupdate",
          //   value: `${moment(new Date()).format("DD/MM/yyyy")}`,
          //   type: "hidden",
          // },
          {
            name: "active",
            value: 1,
            type: "hidden",
          },
          {
            label: "Voucher NO",
            name: "voucherno",
            value: "",
            type: "number",
            placeholder: "Enter Voucher Number",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Date",
            name: "date",
            value: moment(new Date()).format("yyyy-MM-DD"),
            type: "date",
            placeholder: "Select date",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Cheque NO",
            name: "chequeno",
            value: "",
            type: "number",
            placeholder: "Enter Cheque Number",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Client Name",
            name: "client",
            value: "",
            type: "text",
            placeholder: "Enter Client Name",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Company Name",
            name: "company",
            value: "",
            type: "dropdown",
            class: "col-md-6",
            dropdownname: "companyname",
            options: [],
            // required: {
            //   required,
            // },
          },
          {
            label: "Bank Name",
            name: "bankname",
            value: "",
            type: "text",
            placeholder: "Enter Bank Name",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Amount",
            name: "amount",
            value: "",
            type: "text",
            placeholder: "Enter Amount",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Cheque Date",
            name: "chequedate",
            value: moment(new Date()).format("yyyy-MM-DD"),
            type: "date",
            placeholder: "Select Cheque date",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Reason",
            name: "reason",
            value: "",
            type: "text",
            placeholder: "Enter Reason",
            class: "col-md-6",
            // required: {
            //   required,
            // },
          },
          {
            label: "Client's Bank",
            name: "clientbank",
            value: "",
            type: "text",
            placeholder: "Enter Client's Bank",
            class: "col-md-6",
          },
        ],
      },
      viewFields: [
        {
          label: 'Voucher No',
          field: 'voucherno',
          type: 'text',
          class: 'col-md-4'
        },
        {
          label: 'Date',
          field: 'date',
          type: 'text',
          class: 'col-md-4'
        },
        {
          label: 'Cheque No',
          field: 'chequeno',
          type: 'text',
          class: 'col-md-4'
        },
        {
          label: 'Client Name',
          field: 'client',
          type: 'text',
          class: 'col-md-4'
        },
        {
          label: 'Company Name',
          field: 'company',
          type: 'dropdown',
          responseValue: 'name',
          class: 'col-md-4'
        },
        {
          label: 'Bank Name',
          field: 'clientbank',
          type: 'text',
          class: 'col-md-4'
        },
        {
          label: 'Amount',
          field: 'amount',
          type: 'text',
          class: 'col-md-4'
        },
        {
          label: 'Cheque Date',
          field: 'chequedate',
          type: 'text',
          class: 'col-md-4'
        },
        {
          label: 'Reason',
          field: 'reason',
          type: 'text',
          class: 'col-md-4'
        },
        {
          label: 'Client Bank',
          field: 'clientbank',
          type: 'text',
          class: 'col-md-4'
        },
      ],
      columns: [
        {
          label: "ID",
          field: "id",
          filterOptions: {
            enabled: true,
            placeholder: "Search ID",
          },
          hidden: true,
        },
        {
          label: "Voucher No",
          field: "voucherno",
          filterOptions: {
            enabled: true,
            placeholder: "Search voucher No",
          },
        },
        {
          label: "Cheque Date",
          field: "chequedate",
          type: 'datetime',
          filterOptions: {
            enabled: true,
            placeholder: "Search Cheque date",
          },
        },
        {
          label: "Cheque No",
          field: "chequeno",
          filterOptions: {
            enabled: true,
            placeholder: "Search Cheque No",
          },
        },
        {
          label: "Client Name",
          field: "client",
          filterOptions: {
            enabled: true,
            placeholder: "Search Client Name",
          },
        },
        {
          label: "Client's Bank",
          field: "clientbank",
          filterOptions: {
            enabled: true,
            placeholder: "Search Client's Bank",
          },
        },
        {
          label: "Company Name",
          field: "company",
          type: "dropdown",
          url: "getCompany",
          responseValue: "name",
          filterOptions: {
            enabled: true,
            placeholder: "Search Company Name",
          },
        },
        {
          label: "Bank Name",
          field: "bank",
          filterOptions: {
            enabled: true,
            placeholder: "Search Bank Name",
          },
        },
        {
          label: "Amount",
          field: "amount",
          filterOptions: {
            enabled: true,
            placeholder: "Search Amount Type",
          },
        },
        {
          label: "Reason",
          field: "reason",
          filterOptions: {
            enabled: true,
            placeholder: "Search Reason Type",
          },
        },
        {
          label: "Enter By",
          field: "enterby",
          type: "staticdropdown",
          responseValue: 'fullname',
          url: 'getUsers',
          filterOptions: {
            enabled: true,
            placeholder: "Search Name",
          },
        },
        {
          label: "Enter Date",
          field: "enterdatetime",
          type: "datetime",
          time: true,
          filterOptions: {
            enabled: true,
            placeholder: "Search Date",
          },
        },
        {
          label: "Modified By",
          field: "modifiedby",
          type: "staticdropdown",
          responseValue: 'fullname',
          url: 'getUsers',
          filterOptions: {
            enabled: true,
            placeholder: "Search Name",
          },
        },
        {
          label: "Modified Date",
          field: "modifieddatetime",
          time: true,
          type: "datetime",
          filterOptions: {
            enabled: true,
            placeholder: "Search Date",
          },
        },

        {
          label: "Action",
          field: "action",
        },
      ],

      edit: "",
      add: "",
      canDelete: "",
    };
  },

  mounted() {
    const userData = JSON.parse(localStorage.getItem("UserRights"));
    const role = JSON.parse(localStorage.getItem("userData")).role;
    if (role !== "admin") {
      userData.map((item) => {
        if (item.modulename == "Cheque Return") {
          this.edit = item.edit;
          this.add = item.add;
          this.canDelete = item.delete;
          if (
            item.edit !== 1 &&
            item.add !== 1 &&
            item.delete !== 1 &&
            item.view !== 1
          ) {
            this.$router.push("/");
          }
        }
      });
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
